import produce from 'immer';
import _ from 'lodash';
import { connect } from 'react-redux';

import { findContentItemById, findPathById } from '../helpers/tree';

// TODO - we used to get this from window global until we did react_on_rails SSR, need to re-evaluate for multiuser
const cmsInitial = {};

// shape of redux cms state:
/*

{
  users: {
    instance: '2c87a79c-445b-4789-ab92-680b8c8e9f1d',
    '2c87a79c-445b-4789-ab92-680b8c8e9f1d': {
      name: 'First Last',
      selection: 'b04ecd64-6a0f-4a56-870f-4c495b364c20',
      color: '#9bfc4b'
    }
  }
}

 */

const userReducer = {
  users: produce((_draft, _action) => {}, null),
};

export default userReducer;

const findSelection = cms => {
  const { content } = cms;
  const contents = content?.contents;
  const selection = cms.users?.[cms.users.instance]?.selection;
  return content?.contentVersion === 1
    ? findContentItemById(contents, selection)
    : _.get(contents, findPathById(contents, selection));
};

export const usersConnector = connect(state => ({
  users: state.cms.users,
  selection: state.cms.users?.[state.cms.users.instance]?.selection,
  selectedItem: findSelection(state.cms),
  currentUser: state.cms.users?.[state.cms.users.instance],
}));

export const usersMiddleware = store => {
  return next => action => {
    return next(action);
  };
};
